import { create } from "zustand";
import type { PlayerSearchOrigin } from "./player-navigation";

export interface OpenedPlayer {
  playfabId: string;
  label: string;
  origin: PlayerSearchOrigin;
}

interface OpenedPlayersState {
  list: OpenedPlayer[];
  upsert: (player: OpenedPlayer) => void;
  remove: (playfabId: string) => void;
  clear: () => void;
}

/** Session-only — refresh wipes the list. */
export const useOpenedPlayersStore = create<OpenedPlayersState>((set) => ({
  list: [],
  upsert: (player) =>
    set((s) => {
      const existing = s.list.findIndex((p) => p.playfabId === player.playfabId);
      if (existing >= 0) {
        // Update label in case it became known later, keep order.
        const next = s.list.slice();
        next[existing] = player;
        return { list: next };
      }
      return { list: [...s.list, player] };
    }),
  remove: (playfabId) =>
    set((s) => ({ list: s.list.filter((p) => p.playfabId !== playfabId) })),
  clear: () => set({ list: [] }),
}));
